import { useEffect, useState } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch ,useSelector } from 'react-redux'
import { useParams } from "react-router-dom";
import { getcase } from '../../redux/actions/cases';
import { truncateTitle } from '../../middleware/truncateTitle';
import { renderText } from '../hooks/TextVeiw';
import { PDFViewer } from '../utils';
import { media } from '../../server';
const Sliceinfo=({sliceName , sliceData})=>{
  return(
    <div className="flex max-w-[25rem] flex-row  gap-2   p-2">
    <p className="text-tcolor-6 font-kufi text-md">{sliceName}:</p>
    <p className="text-tcolor-4 font-kufi text-md font-semibold dark:text-tcolor-1">{sliceData}</p>
  </div>
  )
}
function ViewCase() {
  const { t } = useTranslation()
  const { id } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getcase(id));
  }, [dispatch, id]);

  const { caseData, isLoadingCase } = useSelector((state) => state.Cases);

  return (<>{
    isLoadingCase ? <div className="loader"></div> :
      <div className="container bg-back-primery rounded-md  p-3 ">
           <h2 className="h2 text-color-1 text-center  dark:text-tcolor-1 mb-4 md:mb-8">{t('case Details')}</h2>
        <div className="flex flex-col">
       
          <div className="flex max-w-[15rem] flex-row gap-4 items-center p-2 border border-gray-300 rounded-lg">
            <p className="text-tcolor-6 font-kufi text-md">{ t("case Number")}:</p>
            <p className="text-tcolor-4 font-kufi text-md font-semibold dark:text-tcolor-1">{caseData?.caseNumber}</p>
          </div>
        
          <div className="grid lg:grid-cols-2 grid-cols-1 mt-10 pt-5 gap-2  border border-b-0 border-l-0 border-r-0  border-t-n-10">
          <Sliceinfo sliceName={t("court Type" )} sliceData={caseData?.courtType} />
          <Sliceinfo sliceName={t("case Type")} sliceData={caseData?.caseType} />
          <Sliceinfo sliceName={t("client Name")} sliceData={truncateTitle(caseData?.clientName,3)} />
          <Sliceinfo sliceName={t("opponant Name")} sliceData={truncateTitle(caseData?.opponentName,3)} />
          <Sliceinfo sliceName={t("next Session Date")} sliceData={caseData?.nextSessionDate} />
          <Sliceinfo sliceName={t("court Name")} sliceData={caseData?.courtName} />
          <div className="flex w-full flex-col  gap-2   p-2">
    <p className="text-tcolor-6 font-kufi text-md">{t("Notes")}:</p>
    <p className="text-tcolor-4 font-kufi text-md p-2 border rounded-md  font-semibold dark:text-tcolor-1">{renderText(caseData?.notes)}</p>
    <div className="grid lg:grid-cols-4  grid-cols-2 md:grid-cols-3 sm:grid-cols-2 sm:gap-4 md:gap-4 xs:gap-4 gap-3 w-full text-color-1 mb-4"> 
    { caseData?.files?.length > 0 && caseData?.files.map((newfile ,i) => (
   <div className="h-[180px] my-2 relative" key={i}>
    <PDFViewer
     
     fileName={newfile instanceof File ? newfile.name : newfile}
     fileUrl={newfile instanceof File ? URL.createObjectURL(newfile) : `${media}${encodeURIComponent(newfile)}`}
   
   />
  </div>))}</div></div>
          </div>
        </div>
      </div>
  }</>
    
  )
}

export default ViewCase